import React from 'react';
import PropTypes from 'prop-types';

export function CustomHeroWrapper({ children }) {
  return <div elementtiming="CustomHeroElement">{children}</div>;
}

CustomHeroWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};
